<div class="pageblock content_area relative">
	<div class="loader" [style.display]="editDisplay(loading)">
		<img src="assets/images/ajax-loader.gif" />
	</div>
	<div id="content-wrapper2">
		<div class="">
			<div class="sixteen columns">
				<menu-component></menu-component>
				<div id="content-top">
					<div class="boxs">
						<ol id="breadcrumb" class="twelve columns alpha breadcrumb">
							<li class="home"><a href="#" [routerLink]="['../home']">Home</a>
							</li>
							<li class="arrow">&nbsp;</li>
							<li>Sessions: Register Session</li>
						</ol>
						<div class="clr"></div>
					</div>
					<div class="clear"></div>
				</div>
			</div>
			<div class="clear"></div>
			<div class="boxs ">
				<div class="title fblue bglightgray">
					<span class="drakbg"><i class="icon_about"></i>You are
						registering for session:</span>
				</div>
				<div class="boxpad create-topic-block">
					<label class="coursetitle">{{courseDetail.courseFullName}}</label>
					<br> <label>By <a href="#" [routerLink]="['../profile']"
							[queryParams]="{ user: courseDetail.createdByUser }"
							class="pageLink">{{courseDetail.createdByUserName}}</a>,
						{{creator.educationalInstitute}} , {{creator.campus}}
					</label> <br>
					<div class="register-course-schedule create-topic-block" style="padding-top: 5px;">
						<div class="ten columns alpha">
							<div class="one columns alpha" style="padding-bottom: 5px;">
								<label class="lblblue">Schedule:
									&nbsp;&nbsp;&nbsp;&nbsp; </label>
								<label>{{courseDetail.displayStartDateOnlyConverted}}
									to {{courseDetail.displayStopDateOnlyConverted}}
									{{courseDetail.timeZoneConverted}}</label>
							</div>
						</div>
						<div class="ApplyPromoCodeWrap">
							<div class="PriceWrap">
								<label class="lblblue">Session Fee: </label> <label *ngIf="courseDetail.cost"
									[class.couponApplied]="couponData.revisedAmount > 0">${{courseDetail.cost}}.0</label>
								<label style="font-weight:600"
									*ngIf="courseDetail.cost && (couponData.revisedAmount > 0)">${{couponData.revisedAmount}}.0</label>
								<label *ngIf="!courseDetail.cost">Free</label>
							</div>
							<div class="promocode promoField" *ngIf="!isPromoCode">
								<label>
									Enter Promo Code (Optional)
								</label>
								<input type="text" (keyup)="couponKeyUp()" [(ngModel)]="couponCode" name="couponCode"
									class="gwt-TextBox" />
							</div>
							<div class="promocode promoField" *ngIf="!isPromoCode">
								<a href="javascript:void(0);" (click)="applyCoupon()"
									class="btncr addPromoBtn">Apply</a>
							</div>
							<div *ngIf="couponError" class="errorDiv" style="color: #f00">
								Invalid coupon code
							</div>
							<div *ngIf="couponInvalid" class="errorDiv" style="color: #f00">
								Invalid coupon code {{couponCode}}
							</div>
							<div class="promocodeAppliedWrap promoField" *ngIf="isPromoCode">
								<label>Applied Promo Code: </label>
								<span>{{couponCode}}</span>
								<span pTooltip="Remove Promo Code" class="promoCodedelete" (click)="removePromo()">
									<i class="fa fa-trash"></i>
								</span>
							</div>
							<div *ngIf="isPromoCode" class="successDiv" style="color: #00bd00">
								Congratulations! your promo code has been successfully applied
							</div>
						</div>
						<br>
						<br>
						<input type="checkbox" [(ngModel)]="acceptTC" name="acceptTC"> I agree with <a
							href="legal/termsandconditions.html" target="_blank">Terms & Conditions</a>
					</div>
				</div>
			</div>
			<div class="boxs">
				<div class="title fblue bglightgray">
					<span class="drakbg"><i class="icon_about"></i>Tutor's
						Contact Details:</span>
				</div>
				<div class="boxpad create-topic-block">
					<label class="lblblue">Name: </label> <label>{{courseDetail.createdByUserName}}</label>
				</div>
			</div>
			<div class="boxs">
				<div class="title fblue bglightgray">
					<span class="drakbg"><i class="icon_about"></i>Billing
						Details:</span>
				</div>
				<form action="" method="post" id="registerForm">
					<div class="boxpad create-topic-block leftsection registercor">
						<div class="four columns alpha">
							<input id="firstName" type="text" [(ngModel)]="details.first_name" name="details.first_name"
								placeholder="First Name*">
						</div>
						<div class="four columns last">
							<input id="lastName" type="text" [(ngModel)]="details.last_name" name="details.last_name"
								placeholder="Last Name*">
						</div>
						<div class="clr"></div>
						<div class="eight columns">
							<input id="street" type="text" [(ngModel)]="details.street" name="details.street"
								placeholder="Billing Address: Street*">
						</div>
						<div class="four columns inptselect">
							<input id="city" type="text" [(ngModel)]="details.city" name="details.city"
								placeholder="City*">
						</div>
						<div class="four columns inptselect last">
							<input id="zip" type="text" [(ngModel)]="details.zip" name="details.zip" placeholder="Zip*">
						</div>
						<div class="clr"></div>
						<div class="four columns inptselect">
							<select [(ngModel)]="country" id="country" name="country">
								<!--                                 <option selected="" value="US">United States</option> -->
								<!--                                 <option value="Other">Other Country</option> -->
								<option [value]="ctr.code" *ngFor="let ctr of countryArr">{{ctr.name}}</option>
							</select>
						</div>
						<div class="four columns inptselect last">
							<input id="state" type="text" [(ngModel)]="details.state" name="details.state"
								placeholder="State Code*">
						</div>
						<div class="clr"></div>
						<div class="eight columns">
							<input id="company-name" type="text" placeholder="Company Name:" name="company-name">
						</div>
					</div>
					<div class="clr"></div>
				</form>
			</div>
			<div class="boxs">
				<!-- <div class="title fblue bglightgray">
					<span class="drakbg"><i class="icon_about"></i>Account
						Information:</span>
				</div> -->
				<!-- <div class="boxpad create-topic-block leftsection registercor">
					<div class="eight columns alpha">
						<input id="cardNumber" type="text" [(ngModel)]="details.card_number" name="details.card_number"
							placeholder="Card Number:" (blur)="validateCardNumber()">
					</div>
					<div style="padding-bottom: 15px;" class="five columns last">
						<img style="BORDER-BOTTOM-STYLE: none; BORDER-RIGHT-STYLE: none; BORDER-TOP-STYLE: none; BORDER-LEFT-STYLE: none"
							alt="VISA" src="assets/images/visa.png"> <img
							style="BORDER-BOTTOM-STYLE: none; BORDER-RIGHT-STYLE: none; BORDER-TOP-STYLE: none; BORDER-LEFT-STYLE: none"
							alt="MASTER CARD" src="assets/images/mastercard.png"> <img
							style="BORDER-BOTTOM-STYLE: none; BORDER-RIGHT-STYLE: none; BORDER-TOP-STYLE: none; BORDER-LEFT-STYLE: none"
							alt="DISCOVER" src="assets/images/discover.png"> <img
							style="BORDER-BOTTOM-STYLE: none; BORDER-RIGHT-STYLE: none; BORDER-TOP-STYLE: none; BORDER-LEFT-STYLE: none"
							alt="PAYPAL" src="assets/images/paypal.png"> <img
							style="BORDER-BOTTOM-STYLE: none; BORDER-RIGHT-STYLE: none; BORDER-TOP-STYLE: none; BORDER-LEFT-STYLE: none "
							alt="amex" src="assets/images/amex.png">
					</div>

					<div class="clear"></div>
					<label class="lblblue">Expires:</label>
					<div class="clr"></div>
					<div class="four columns alpha inptselect">
						<select id="month" [(ngModel)]="details.expire_month" name="details.expire_month">
							<option selected="">01</option>
							<option selected="">02</option>
							<option selected="">03</option>
							<option selected="">04</option>
							<option selected="">05</option>
							<option selected="">06</option>
							<option selected="">07</option>
							<option selected="">08</option>
							<option selected="">09</option>
							<option selected="">10</option>
							<option selected="">11</option>
							<option selected="">12</option>
						</select>
					</div>
					<div class="four columns inptselect last">
						<select id="year" [(ngModel)]="details.expire_year" name="details.expire_year">
							<option>2017</option>
							<option>2018</option>
							<option>2019</option>
							<option>2020</option>
							<option>2021</option>
							<option>2022</option>
							<option>2023</option>
							<option>2024</option>
							<option>2025</option>
							<option>2026</option>
							<option>2027</option>
							<option>2028</option>
							<option>2029</option>
							<option>2030</option>
							<option>2031</option>
							<option>2032</option>
							<option>2033</option>
							<option>2034</option>
							<option>2035</option>
							<option>2036</option>
							<option>2037</option>
						</select>
					</div>
					<div class="clr"></div>
					<input type="hidden" name="coid" value="47"> <input type="hidden" name="contextPathURL" value="">
					<input type="hidden" name="type" value="">
					<div class="four columns alpha">
						<input id="cvv" type="text" [(ngModel)]="details.cvv" name="details.cvv"
							placeholder="Security Code:">
					</div>
					<div class="four columns last">
						<label>The last 3 number from the back of your card.</label>
					</div>
					<div class="clr"></div>
				</div> -->
				<div class="clr"></div>
				<div class="five columns alpha boxpad">
					<!-- <input id="pay" value="Pay Now and Register" (click)="ccPay(courseDetail.courseId)" type="button"
						name="pay"> -->
					<!-- <input type="button" style="width: 49%;" (click)="paypalPay(courseDetail.courseId)" value="Pay With PayPal Account">  -->
					<div role="button" data-button="" (click)="paypalPay(courseDetail.courseId)"
						data-funding-source="paypal"
						class="paypal-button paypal-button-number-0 paypal-button-layout-vertical paypal-button-shape-pill paypal-button-number-multiple paypal-button-env-sandbox paypal-button-color-gold paypal-button-text-color-black paypal-logo-color-blue paypal-button-clicked"
						tabindex="0">
						<div class="paypal-button-label-container"><span class="paypal-button-text" optional="">Pay with
							</span><img
								src="data:image/svg+xml;base64,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"
								alt="PP" class="paypal-logo paypal-logo-pp paypal-logo-color-blue"><span
								class="paypal-button-space"> </span><img
								src="data:image/svg+xml;base64,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"
								alt="PayPal" class="paypal-logo paypal-logo-paypal paypal-logo-color-blue"></div>
						<div class="paypal-button-spinner"></div>
					</div>
					<a href="#" style="width: 50%; border-radius: 23px;" [routerLink]="['../onlinecourse']"
						class="pageLink4 btnstyle">Cancel</a>
				</div>
			</div>
			<!-- <DIV class="three columns last">
        <FORM method=post action='home.do'>
          <INPUT id=cancel value=Cancel type=submit name=cancel>
        </FORM>
      </DIV> -->
		</div>
	</div>
</div>
<div [style.display]="editDisplay(popUp)"
	class="ui-dialog ui-widget ui-widget-content ui-corner-all ui-front ui-dialog-buttons ui-draggable ui-resizable"
	tabindex="-1" role="dialog" aria-describedby="errorDialog" aria-labelledby="ui-id-1"
	style="position: fixed; height: auto; width: 300px; top: 200px; left: 44% !important; display: none;">
	<div class="ui-dialog-titlebar ui-widget-header ui-corner-all ui-helper-clearfix">
		<span id="ui-id-1" class="ui-dialog-title">{{msgTitle}}</span>
		<button (click)="popUp = false;"
			class="ui-button ui-widget ui-state-default ui-corner-all ui-button-icon-only ui-dialog-titlebar-close"
			role="button" aria-disabled="false" title="close">
			x
		</button>
	</div>
	<div class="ui-dialog-content ui-widget-content"
		style="width: auto; min-height: 33px; max-height: none; height: auto;">
		<ul>
			<li>{{msgContent}}</li>
		</ul>
	</div>
	<div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix">
		<div class="ui-dialog-buttonset">
			<button type="button" class="ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only"
				(click)="popUp = false;" role="button" aria-disabled="false">
				<span class="ui-button-text">Close</span>
			</button>
		</div>
	</div>
	<div class="ui-resizable-handle ui-resizable-n" style="z-index: 90;"></div>
	<div class="ui-resizable-handle ui-resizable-e" style="z-index: 90;"></div>
	<div class="ui-resizable-handle ui-resizable-s" style="z-index: 90;"></div>
	<div class="ui-resizable-handle ui-resizable-w" style="z-index: 90;"></div>
	<div class="ui-resizable-handle ui-resizable-se ui-icon ui-icon-gripsmall-diagonal-se" style="z-index: 90;"></div>
	<div class="ui-resizable-handle ui-resizable-sw" style="z-index: 90;"></div>
	<div class="ui-resizable-handle ui-resizable-ne" style="z-index: 90;"></div>
	<div class="ui-resizable-handle ui-resizable-nw" style="z-index: 90;"></div>
</div>

<uvsity-modal-popup [isModalDialogToBeDisplayed]="showErrorModalDialog" [messageTitle]="showErrorMessageTitle"
	[messages]="showErrorMessages" (uvsityModalPopupClosed)="closeErrorPopup()"
	[popupWidthPercentage]="showErrorPopupWidthInPercentage" [pleaseWait]="pleaseWait" [isSignUp]="isSignUp"
	[isValidationError]="isValidationError">
</uvsity-modal-popup>